import MicroModal from 'micromodal';

const CONSENT_COOKIE_NAME = 'mf_consent_popup_seen';
const CONSENT_COOKIE_VALUE = '1';
const COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60;

const consentModal = () => {
	const modalId = 'modal-consent-popup';
	const confirmButton = document.getElementById('modal-consent-popup-confirm');
	const modalElement = document.getElementById(modalId);

	if (!modalElement || !confirmButton) {
		return;
	}

	const hasConsentCookie = () => {
		return document.cookie.split('; ').some((cookie) => cookie === `${CONSENT_COOKIE_NAME}=${CONSENT_COOKIE_VALUE}`);
	};

	const setConsentCookie = () => {
		document.cookie = `${CONSENT_COOKIE_NAME}=${CONSENT_COOKIE_VALUE}; max-age=${COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
	};

	if (!hasConsentCookie()) {
		MicroModal.show(modalId, {
			awaitCloseAnimation: true,
			disableScroll: false,
			disableFocus: false,
			onShow: () => {
				document.addEventListener('keydown', blockEsc, true);
			},
			onClose: () => {
				document.removeEventListener('keydown', blockEsc, true);
			},
		});

		function blockEsc(e) {
			if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
				e.stopPropagation();
				e.preventDefault();
			}
		}
	}

	confirmButton.addEventListener('click', () => {
		setConsentCookie();
		MicroModal.close(modalId);
	});
};

export default consentModal;
